;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import React from 'react';
import { Row, Col } from 'reactstrap';
import { Dictionaries, Locale } from '../../i18n/i18n-config';
import { getI18nUtils } from '../../i18n/i18n-utils';
import LoginWithEmail from './LoginWithEmail';
import LoginWithProvider from './LoginWithProvider';

type Props = {
  emailAddress?: string;
  inline?: boolean;
  dictionary: Partial<Dictionaries>;
  locale: Locale;
};
function Login({ emailAddress, inline, dictionary, locale }: Props) {
  const { formatMessage } = getI18nUtils(dictionary);

  if (inline) {
    return (
      <Row>
        <Col xl={{ size: 7 }}>
          <Row>
            <Col xl={{ size: 11 }}>
              <LoginWithEmail locale={locale} emailAddress={emailAddress} dictionary={dictionary} />
            </Col>
            <Col xl={{ size: 1 }} className="border-end" />
          </Row>
        </Col>
        <hr className="my-4 d-xl-none" />
        <Col xl={{ size: 5 }}>
          <Row>
            <Col xl={{ size: 11, offset: 1 }} className="d-flex justify-content-center d-xl-block">
              <div className="mt-xl-4">
                <small className="w-100 w-lg-auto text-center d-inline-block mb-3">
                  {formatMessage({ id: 'login-continue-with' })}
                </small>
                <LoginWithProvider dictionary={dictionary} />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }

  return (
    <div id="loginContainer">
      <LoginWithEmail locale={locale} emailAddress={emailAddress} dictionary={dictionary} />
      <div className="position-relative my-3">
        <hr className="position-absolute w-100" style={{ top: '4px', zIndex: -1 }} />
        <div className="d-block mx-auto bg-white px-4 py-2" style={{ width: 'fit-content' }}>
          {formatMessage({ id: 'login-continue-with' })}
        </div>
      </div>
      <div className="d-flex justify-content-center align-items-center my-3">
        <LoginWithProvider centerButtons dictionary={dictionary} />
      </div>
    </div>
  );
}

export default Login;
